import { ReactElement } from 'react';

import { Skeleton, Stack, TableCell, TableRow } from '@mui/material';

import { getRandomNumberInclusive } from '@/utils';

export const SkeletonCreditsTableRow = (): ReactElement => {
  return (
    <TableRow>
      {/* File name */}
      <TableCell>
        <Skeleton variant="rounded" width={30} height={21} />
      </TableCell>

      {/* Company name */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(100, 200)}
          height={21}
        />
      </TableCell>

      {/* Status */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(40, 64)}
          height={21}
        />
      </TableCell>

      {/* Created by */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(100, 200)}
          height={21}
        />
      </TableCell>

      {/* Date created */}
      <TableCell>
        <Skeleton variant="rounded" width={90} height={21} />
      </TableCell>

      {/* Date modified */}
      <TableCell>
        <Skeleton variant="rounded" width={90} height={21} />
      </TableCell>

      {/* Action button(s) */}
      <TableCell>
        <Stack direction="row" spacing={0.5}>
          <Skeleton variant="circular" width={28} height={28} />
        </Stack>
      </TableCell>
    </TableRow>
  );
};
